import React, { Component, useContext } from "react";
import PropTypes from "prop-types";
import { fetchAllDeliveryZones } from "../api/DeliveryZones";
import { alertMessage } from "../common/Common";
import {TreeSelect } from "../common/UIComponents";
import { withRouter } from "react-router";
import { OrgContext } from "../context/OrgContext";
import { WarehouseContext } from "../context/WarehouseContext";
import { renderAlertMessage } from "../helpers/common";
const { TreeNode } = TreeSelect;

class ZonesList extends Component {
	constructor() {
		super();
		this.state = {
			zones: [],
			isLoading: false,
			selectedZoneIds: [],
			searchValue: "",
		};
		this.getAllZones = this.getAllZones.bind(this);
	}
	componentDidMount() {
		this.getAllZones();
		this.setState({selectedZoneIds: this.props.zone_ids || []});
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.zone_ids !== this.props.zone_ids) {
		this.setState({
			selectedZoneIds: this.props.zone_ids || [],
		});
		}
		if (prevProps.warehouseFilter.selectedWarehouses !== this.props.warehouseFilter.selectedWarehouses) {
			this.getAllZones();
		}
		// Clear the typed search text when the parent bumps resetSearchToken
		// (e.g. on the filter panel's Search / Reset button click).
		if (prevProps.resetSearchToken !== this.props.resetSearchToken) {
			this.setState({ searchValue: "" });
		}
	}


	getAllZones() {
		this.setState({ isLoading: true });
		fetchAllDeliveryZones().then((result) => {
			if (result.success) {
				this.setState({ zones: result.zones, isLoading: false });
				this.props.onZonesChange(result.zones);
			} else {
				renderAlertMessage(result.errors)
				this.setState({ isLoading: false });
			}
		});
	}

	handleSearch = (value) => {
		this.setState({ searchValue: value });
	};

	// Same title match the dropdown uses (title = name) so the zones we compute
	// here are exactly the rows currently visible under the search. Returned as
	// labelInValue objects to match the TreeSelect's value shape.
	getFilteredZoneObjs = (text) => {
		const q = (text || "").toLowerCase();
		return this.state.zones
			.filter((zone) => `${zone.name}`.toLowerCase().indexOf(q) >= 0)
			.map((zone) => ({ value: zone.id, label: zone.name, key: zone.id }));
	};

	handleOnChange = (selectedZones, _label, extra) => {
		const triggerValue = extra && extra.triggerValue;
		const searchText = this.state.searchValue;
		const searching = !!(searchText && searchText.trim().length > 0);

		// When "All" is ticked while a search is active, antd would select every
		// zone (the hidden ones too). Instead, scope "All" to the matching rows:
		// add them to the current selection (or remove them if they were all
		// already selected — mirrors the checkbox's tri-state).
		if (triggerValue === "ALL" && searching) {
			const current = this.state.selectedZoneIds || [];
			const currentKeys = current.map((z) => String(z.value));
			const filteredObjs = this.getFilteredZoneObjs(searchText);
			const filteredKeys = filteredObjs.map((z) => String(z.value));
			const allAlreadySelected =
				filteredKeys.length > 0 && filteredKeys.every((k) => currentKeys.includes(k));

			let next;
			if (allAlreadySelected) {
				next = current.filter((z) => !filteredKeys.includes(String(z.value)));
			} else {
				const toAdd = filteredObjs.filter((z) => !currentKeys.includes(String(z.value)));
				next = [...current, ...toAdd];
			}
			this.props.handleFilterPlaceHolderChange("zone_ids", next);
			this.setState({ selectedZoneIds: next, ...(next.length === 0 ? { searchValue: "" } : {}) });
			return;
		}

		// check if all is selected then set all zones , else set selected zones
		const filteredZones = selectedZones.length
			? selectedZones[0].key === "all"
				? selectedZones.slice(1)
				: selectedZones[selectedZones.length - 1].key === "all"
				? []
				: selectedZones
			: [];
		this.props.handleFilterPlaceHolderChange("zone_ids", filteredZones);
		// Clearing the selection (field ✕ / unchecking the last item) also clears
		// the leftover typed search text.
		this.setState({
			selectedZoneIds: filteredZones,
			...(filteredZones.length === 0 ? { searchValue: "" } : {}),
		});
	};

	render() {
		const { isLoading, zones, selectedZoneIds } = this.state;
		return (
			<TreeSelect
			value={selectedZoneIds}
				labelInValue
				showSearch
				searchValue={this.state.searchValue}
				onSearch={this.handleSearch}
				autoClearSearchValue={false}
				showArrow
				style={{ width: "100%" }}
				className="minWidth"
				dropdownStyle={ {
					maxHeight: 300,
					overflow: "auto",
					maxWidth:300,
				  } }
				placeholder="--Select--"
				allowClear
				treeDefaultExpandAll
				dropdownMatchSelectWidth={ true }
				treeCheckable
				maxTagCount={ 1 }
				treeNodeFilterProp="title"
				filterOption={(input, option) =>
					option.props.children
						.toLowerCase()
						.indexOf(input.toLowerCase()) >= 0
				}
				onChange={this.handleOnChange}
				mode="multiple"
				loading={isLoading}
			>
				<TreeNode value="ALL" title="All" key="all">
                {zones.map((zone) => (
                 <TreeNode
                   value={ zone.id}
                   title={ `${zone.name}` }
                   key={ zone.id}
            />
          )) }
        </TreeNode>
			</TreeSelect>

			 
		);
	}
}
export const ZonesListComponent = withRouter((props) => {
  const warehouseFilter = useContext(WarehouseContext);
  const { orgSettings : organizationSettings  }= useContext(OrgContext);
  return (
    <ZonesList
      warehouseFilter={warehouseFilter}
      organizationSettings={organizationSettings}
      {...props}
    />
  );
});

export default ZonesListComponent;

ZonesListComponent.propTypes = {
	onZonesChange: PropTypes.func,
};

ZonesListComponent.defaultProps = {
	onZonesChange: () => {},
};



// not tree select
// import React, { Component, useContext } from "react";
// import PropTypes from "prop-types";
// import { fetchAllDeliveryZones } from "../api/DeliveryZones";
// import { alertMessage } from "../common/Common";
// import { Select } from "antd";
// import { withRouter } from "react-router";
// import { OrgContext } from "../context/OrgContext";
// import { WarehouseContext } from "../context/WarehouseContext";

// const { Option } = Select;

// class ZonesList extends Component {
// 	constructor () {
// 		super();
// 		this.state = {
// 			zones: [],
// 			isLoading: false,
// 			selectedZoneIds: [],
// 		};
// 		this.getAllZones = this.getAllZones.bind(this);
// 	}

// 	componentDidMount () {
// 		this.getAllZones();
// 		this.setState({ selectedZoneIds: this.props.zone_ids || [] });
// 	}

// 	componentDidUpdate (prevProps) {
// 		if (prevProps.zone_ids !== this.props.zone_ids) {
// 			this.setState({
// 				selectedZoneIds: this.props.zone_ids || [],
// 			});
// 		}
// 		if (
// 			prevProps.warehouseFilter.selectedWarehouses !==
// 			this.props.warehouseFilter.selectedWarehouses
// 		) {
// 			this.getAllZones();
// 		}
// 	}

// 	getAllZones () {
// 		this.setState({ isLoading: true });
// 		fetchAllDeliveryZones().then((result) => {
// 			if (result.success) {
// 				this.setState({ zones: result.zones, isLoading: false });
// 				this.props.onZonesChange(result.zones);
// 			} else {
// 				alertMessage(result.errors[ 0 ], "error", 10);
// 				this.setState({ isLoading: false });
// 			}
// 		});
// 	}

// 	handleOnChange = (selectedZones) => {
// 		// this.props.handleFilterPlaceHolderChange("zone_ids", selectedZones);
// 		this.setState({
// 			selectedZoneIds: selectedZones,
// 		});
// 	};

// 	render () {
// 		const { isLoading, zones, selectedZoneIds } = this.state;
// 		return (
// 			<Select
// 				value={ selectedZoneIds }
// 				mode="multiple"
// 				style={ { width: "100%" } }
// 				placeholder="--Select--"
// 				allowClear
// 				maxTagCount={ 1 }
// 				showSearch
// 				optionFilterProp="children"
// 				loading={ isLoading }
// 				onChange={ this.handleOnChange }
// 			>
// 				{ zones.map((zone) => (
// 					<Option key={ zone.id } value={ zone.id }>
// 						{ zone.name }
// 					</Option>
// 				)) }
// 			</Select>
// 		);
// 	}
// }

// export const ZonesListComponent = withRouter((props) => {
// 	const warehouseFilter = useContext(WarehouseContext);
// 	const { orgSettings: organizationSettings } = useContext(OrgContext);
// 	return (
// 		<ZonesList
// 			warehouseFilter={ warehouseFilter }
// 			organizationSettings={ organizationSettings }
// 			{ ...props }
// 		/>
// 	);
// });

// export default ZonesListComponent;

// ZonesListComponent.propTypes = {
// 	onZonesChange: PropTypes.func,
// };

// ZonesListComponent.defaultProps = {
// 	onZonesChange: () => { },
// };
